module.exports = __webpack_public_path__ + "static/media/mobilehra123.6f88ebcf.webp";